import React from "react";
import { Row, Col, Space, Tooltip, message, Button, Modal } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import ListTable from "./ListTable";

import config from "../config";

import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import DiscountStore from "../store/DiscountStore";
import DiscountAdd from "./DiscountAdd";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";

class DiscountList extends React.Component {
  constructor(props) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.discountStore = new DiscountStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openDiscountForm: false,
    };
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });

    this.columns = [
      {
        title: this.context.translate("_COMAPNY_NAME_"),
        dataIndex: "name",
        width: "20%",
        render: (val, record) => {
          return (
            <Link
              onClick={(e) => {
                e.preventDefault();
                this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        title: this.context.translate("_VEHICLE_TYPE_"),
        dataIndex: "vehicleType",
        width: "15%",
      },
      {
        title: this.context.translate("_DISCOUNT_NAME_"),
        dataIndex: "discountName",
        width: "15%",
      },
      {
        title: this.context.translate("_DISCOUNT_TYPE_"),
        dataIndex: "discountType",
        width: "15%",
        render: (value) => {
          if (value == 1) {
            return <>%</>;
          } else if (value == 2) {
            return <>Flat Amount</>;
          }
        },
      },
      {
        title: this.context.translate("_DISCOUNT_"),
        dataIndex: "discountAmount",
        width: "20%",
      },
      {
        title: this.context.translate("_VALID_FROM_"),
        dataIndex: "validFrom",
        width: "20%",
      },
      {
        title: this.context.translate("_VALID_TO_"),
        dataIndex: "validTo",
        width: "20%",
      },
      {
        title: this.context.translate("_ACTION_"),
        dataIndex: "action",
        width: "6%",
        render: (_, record) => {
          return (
            <>
              <Space>
                <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Tooltip
                    placement="bottom"
                    // title="Delete Record"
                    title={this.context.translate("_DELETE_RECORD_")}
                    color={config.tooltipColorDelete}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Tooltip>
                </DeleteConfirm>
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      let setdiscountData = this.context.viewStateStore.discountObject;

      setdiscountData =
        typeof setdiscountData === "number"
          ? setdiscountData
          : setdiscountData.companyId;

      if (setdiscountData !== "") {
        await this.discountStore.loadData({
          companyId: setdiscountData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setdiscountData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setdiscountData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setDiscountStates({
      companyId: record.companyId,
    });
    await this.setState({ discountId: record.discountId });
    await this.setState({ openDiscountForm: true });
  };

  async onDelete(record) {
    const response = await this.discountStore.deleteRecord({
      discountId: record.discountId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.discountStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openDiscountForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openDiscountForm: false });
      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };

  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_DISCOUNT_LIST_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  placement="left"
                  //  title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() =>
                      this.setState({ openDiscountForm: true, discountId: "" })
                    }
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  value={this.state.comp_value ? this.state.comp_value : null}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.discountStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.discountStore?.discountList}
            loading={this.discountStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openDiscountForm && (
          <Modal
            bodyStyle={{ height: "645px" }}
            className="formShowModal"
            title={this.context.translate("_ADD_DISCOUNT_")}
            centered
            open={this.state.openDiscountForm}
            footer={null}
            onCancel={() => {
              this.setState({ openDiscountForm: false, discountId: "" });
            }}
            width={665}
          >
            <div>
              <DiscountAdd
                discountId={this.state.discountId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Modal>
        )}
      </>
    );
  }
}
DiscountList.contextType = StoreContext;
export default observer(withRouter(DiscountList));
